var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/contentful/navigation-treatment-macro.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
[], 
["prefix", "navigationTreatments"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("prefix", kwargs.hasOwnProperty("prefix") ? kwargs["prefix"] : "");
frame.set("navigationTreatments", kwargs.hasOwnProperty("navigationTreatments") ? kwargs["navigationTreatments"] : []);
var t_2 = "";t_2 += "<style>";
frame = frame.push();
var t_5 = runtime.contextOrFrameLookup(context, frame, "navigationTreatments");
if(t_5) {var t_4 = t_5.length;
for(var t_3=0; t_3 < t_5.length; t_3++) {
var t_6 = t_5[t_3];
frame.set("treatment", t_6);
frame.set("loop.index", t_3 + 1);
frame.set("loop.index0", t_3);
frame.set("loop.revindex", t_4 - t_3);
frame.set("loop.revindex0", t_4 - t_3 - 1);
frame.set("loop.first", t_3 === 0);
frame.set("loop.last", t_3 === t_4 - 1);
frame.set("loop.length", t_4);
var t_7;
t_7 = "#" + "" + runtime.contextOrFrameLookup(context, frame, "prefix") + "" + (lineno = 23, colno = 56, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_6,"fields.slug"]));
frame.set("baseSelector", t_7, true);
if(frame.topLevel) {
context.setVariable("baseSelector", t_7);
}
if(frame.topLevel) {
context.addExport("baseSelector", t_7);
}
var t_8;
t_8 = runtime.contextOrFrameLookup(context, frame, "baseSelector") + "" + ":hover," + "" + runtime.contextOrFrameLookup(context, frame, "baseSelector") + "" + ":focus";
frame.set("hoverSelector", t_8, true);
if(frame.topLevel) {
context.setVariable("hoverSelector", t_8);
}
if(frame.topLevel) {
context.addExport("hoverSelector", t_8);
}
var t_9;
t_9 = (lineno = 26, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_6,"fields.imageTreatment.fields.defaultImage.fields.file.url"]));
frame.set("defaultImageUrl", t_9, true);
if(frame.topLevel) {
context.setVariable("defaultImageUrl", t_9);
}
if(frame.topLevel) {
context.addExport("defaultImageUrl", t_9);
}
var t_10;
t_10 = (lineno = 27, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_6,"fields.imageTreatment.fields.hoverImage.fields.file.url"]));
frame.set("hoverImageUrl", t_10, true);
if(frame.topLevel) {
context.setVariable("hoverImageUrl", t_10);
}
if(frame.topLevel) {
context.addExport("hoverImageUrl", t_10);
}
var t_11;
t_11 = (lineno = 28, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_6,"fields.imageTreatment.fields.keepText",runtime.contextOrFrameLookup(context, frame, "True")]));
frame.set("keepText", t_11, true);
if(frame.topLevel) {
context.setVariable("keepText", t_11);
}
if(frame.topLevel) {
context.addExport("keepText", t_11);
}
var t_12;
t_12 = (lineno = 29, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_6,"fields.imageTreatment.fields.width"]));
frame.set("imageWidth", t_12, true);
if(frame.topLevel) {
context.setVariable("imageWidth", t_12);
}
if(frame.topLevel) {
context.addExport("imageWidth", t_12);
}
var t_13;
t_13 = (lineno = 30, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_6,"fields.fontColor"]));
frame.set("fontColor", t_13, true);
if(frame.topLevel) {
context.setVariable("fontColor", t_13);
}
if(frame.topLevel) {
context.addExport("fontColor", t_13);
}
var t_14;
t_14 = (lineno = 31, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_6,"fields.hoverColor"]));
frame.set("hoverColor", t_14, true);
if(frame.topLevel) {
context.setVariable("hoverColor", t_14);
}
if(frame.topLevel) {
context.addExport("hoverColor", t_14);
}
if(runtime.contextOrFrameLookup(context, frame, "defaultImageUrl")) {
t_2 += runtime.suppressValue((lineno = 34, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "generateImageTreatment"), "generateImageTreatment", context, [runtime.contextOrFrameLookup(context, frame, "baseSelector"),runtime.contextOrFrameLookup(context, frame, "defaultImageUrl"),runtime.contextOrFrameLookup(context, frame, "keepText"),runtime.contextOrFrameLookup(context, frame, "imageWidth")])), env.opts.autoescape);
;
}
if(runtime.contextOrFrameLookup(context, frame, "hoverImageUrl")) {
t_2 += runtime.suppressValue((lineno = 37, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "generateImageTreatment"), "generateImageTreatment", context, [runtime.contextOrFrameLookup(context, frame, "hoverSelector"),runtime.contextOrFrameLookup(context, frame, "hoverImageUrl"),runtime.contextOrFrameLookup(context, frame, "keepText"),runtime.contextOrFrameLookup(context, frame, "imageWidth")])), env.opts.autoescape);
;
}
if(runtime.contextOrFrameLookup(context, frame, "keepText")) {
if(runtime.contextOrFrameLookup(context, frame, "fontColor")) {
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "baseSelector"), env.opts.autoescape);
t_2 += runtime.suppressValue("{color:" + "" + runtime.contextOrFrameLookup(context, frame, "fontColor") + "" + ";}", env.opts.autoescape);
;
}
if(runtime.contextOrFrameLookup(context, frame, "hoverColor")) {
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "hoverSelector"), env.opts.autoescape);
t_2 += runtime.suppressValue("{color:" + "" + runtime.contextOrFrameLookup(context, frame, "hoverColor") + "" + ";}", env.opts.autoescape);
;
}
;
}
;
}
}
frame = frame.pop();
t_2 += "</style>";
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("generateTreatmentStyles");
context.setVariable("generateTreatmentStyles", macro_t_1);
var macro_t_15 = runtime.makeMacro(
[], 
["selector", "url", "keepText", "imageWidth"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("selector", kwargs.hasOwnProperty("selector") ? kwargs["selector"] : "");
frame.set("url", kwargs.hasOwnProperty("url") ? kwargs["url"] : "");
frame.set("keepText", kwargs.hasOwnProperty("keepText") ? kwargs["keepText"] : runtime.contextOrFrameLookup(context, frame, "True"));
frame.set("imageWidth", kwargs.hasOwnProperty("imageWidth") ? kwargs["imageWidth"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_16 = "";t_16 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "selector"), env.opts.autoescape);
t_16 += "\n    ";
t_16 += runtime.suppressValue(env.getFilter("safe").call(context, "{background:url(\""), env.opts.autoescape);
t_16 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "url"), env.opts.autoescape);
t_16 += runtime.suppressValue(env.getFilter("safe").call(context, "\") no-repeat center top;"), env.opts.autoescape);
t_16 += "\n    ";
t_16 += runtime.suppressValue((!runtime.contextOrFrameLookup(context, frame, "keepText")?"color:transparent;":""), env.opts.autoescape);
t_16 += "\n    ";
t_16 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "imageWidth")?"width:" + "" + runtime.contextOrFrameLookup(context, frame, "imageWidth") + "" + "px;":""), env.opts.autoescape);
t_16 += "\n    ";
t_16 += runtime.suppressValue("background-size:contain;}", env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_16);
});
context.addExport("generateImageTreatment");
context.setVariable("generateImageTreatment", macro_t_15);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/contentful/navigation-treatment-macro.j2"] , dependencies)